<template>
  <!--
    其它合同： contractSource 2
    驳回合同：contractSource 1  verifyStatus 2
    已审核合同：contractSource 1 verifyStatus 1
    未审核合同：contractSource 1 verifyStatus 0
 -->
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel" />
        </div>
      </div>
      <div class="input-wrap">
        <van-cell-group>
          <!-- <van-field v-model="queryParams.companyName" readonly @click="showPicker('company')" label="收款主体" placeholder="请选择收款主体" />
          <van-field v-model="queryParams.incomeBankName" readonly @click="queryParams.companyId?showPicker('incomeBank'):''" label="收款银行账号" placeholder="请选择收款银行账号" :disabled="!queryParams.companyId" /> -->
          <van-field v-model="queryParams.contractNum" label="合同编号" placeholder="请输入合同编号" />
          <van-field v-model="queryParams.contractName" label="合同名称" placeholder="请输入合同名称" />
          <van-field v-model="queryParams.execCustomerName" label="付款单位" placeholder="请输入付款单位" />
          <van-field v-model="queryParams.custName" label="付款单位" placeholder="请输入付款单位" />
          <van-field v-model="queryParams.deptName" readonly @click="showPicker('dept')" label="部门" placeholder="请选择部门" />
          <van-field v-model="queryParams.userName" label="业务员" placeholder="请输入业务员" />
          <!-- <van-field v-model="queryParams.mediaUserName" label="媒介人员" placeholder="请输入媒介人员" />
          <van-field v-model="queryParams.accountNo" label="账户ID" placeholder="请输入账户ID" /> -->
          <!-- <van-field readonly clickable v-model="serviceTypeName" @click="showPicker2('service')" label="业务类型" placeholder="请选择业务类型" />
          <van-field v-model="queryParams.signedUser" label="对方签约人" placeholder="请输入对方签约人" />
          <van-field v-model="queryParams.signedUserMobile" label="对方电话" placeholder="请输入对方电话" />
          <van-field v-model="queryParams.signedUserWx" label="对方微信号" placeholder="请输入对方微信号" />
          <van-field readonly clickable v-model="deptName" @click="showPicker('dept')" label="我方签约部门" placeholder="选择我方签约部门" /> -->
          <!-- <van-field v-model="queryParams.userName" label="对应业务员" placeholder="请输入对应业务员" /> -->
          <!-- <van-field v-model="queryParams.userName" label="业务员" placeholder="请输入业务员" />
          <van-field readonly clickable v-model="queryParams.companyName" @click="showPicker('company')" label="我方主体机构" placeholder="选择我方主体机构" /> -->
          <van-field v-model="signTime" readonly clickable name="calendar" label="创建日期" placeholder="点击选择创建日期" @click="showCalendar('signTime')" />
          <!-- <van-field v-model="executionTime" readonly clickable name="calendar" label="执行时间" placeholder="点击选择执行时间" @click="showCalendar('executionTime')" /> -->
          <!-- <van-field v-if="type == 'channel'" v-model="queryParams.execCustomerNames" label="执行客户" placeholder="请输入执行客户" /> -->
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" @change="treeChange" :field-names="tree.fieldNames" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>

    <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :type="datePicker.type" @confirm="dateConfirm" />
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import { Field, Popup, Icon, Button, Cell, CellGroup, CollapseItem, Divider, Collapse, Calendar, Picker, Cascader } from 'vant'
import { businessTypeList, companyList } from '@/api/admi/dept'
import { getDicts } from '@/api/system/dict/data'
import statistics from '@/api/tongji/statistics'
export default {
  name: 'SearchPop',
  props: {
    show: Boolean,
    type: String
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    }
  },
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Divider.name]: Divider,
    [Calendar.name]: Calendar,
    [Picker.name]: Picker,
    vanCascader: Cascader
  },
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        type: 'single',
        formKey: ''
      },
      executionTime: '',
      signTime: '',
      serviceTypeName: '',
      serviceTypeTreeList: '',
      deptList: [],
      companyList: [], // 公司列表
      value: null,
      showPop: false,
      activeNames: ['1'],
      contractTypeIndex: null,
      contractStatusIndex: null,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      businessTypeName: null,
      deptName: null,
      queryParams: {
        params: {
          beginTime: '',
          endTime: ''
        }
      },
      contractStatusName: '',
      options: {
        contractStatusOptions: []
      },
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || []
    }
  },
  mounted() {
    if (sessionStorage.getItem('rechargeSearch')) {
      this.queryParams = { ...this.queryParams, ...JSON.parse(sessionStorage.getItem('rechargeQuery')) }
      if (this.queryParams.params.beginTime && this.queryParams.params.endTime) { this.signTime = `${this.queryParams.params.beginTime} 至 ${this.queryParams.params.endTime}` }
    }
  },
  methods: {
    handleClick(type, prop, index) {
      switch (type) {
        case 'contractType':
          this.queryParams.contractType = prop
          this.contractTypeIndex = index
          break
        case 'contractStatus':
          this.queryParams.contractStatus = prop
          this.contractStatusIndex = index
          break
        default:
          console.log('handleClick', type, prop)
      }
    },
    resetQuery() {
      this.serviceTypeName = ''
      this.deptName = ''
      this.queryParams = {
        // launchType: null,
        // contractStatus: null,
        // custName: null,
        signedUser: null,
        signedUserMobile: null,
        signedUserWx: null,
        deptId: null,
        contractNum: null,
        contractName: null,
        // signedUser: null,
        userName: null,
        // businessType: null,
        // params: null,
        // serviceTypeId: null,
        // signTime: '',
        // startTime: '',
        // endTime: ''
        params: {
          beginTime: '',
          endTime: ''
        },
        companyName: null,
        companyId: null,
        incomeBankId: null,
        incomeBankName: null,

        execCustomerName: null
      }
      this.value = null
      this.contractTypeIndex = null
      this.contractStatusIndex = null
      this.businessTypeName = null
      this.businessTypeId = null
      this.contractStatusName = null
      this.executionTime = null
      this.signTime = null
      sessionStorage.removeItem('rechargeSearch')
      sessionStorage.removeItem('rechargeQuery')
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    // formatDate(date) {
    //   // 时间格式化 2019-09-08
    //   let year = date.getFullYear();
    //   let month = date.getMonth() + 1;
    //   let day = date.getDate();
    //   return year + "-" + month + "-" + day;
    // },
    // onConfirm(date) {
    //   const [start, end] = date;
    //   this.showCalendar = false;
    //   this.value = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    //   let params = {
    //     beginTime: this.formatDate(start),
    //     endTime: this.formatDate(end)
    //   }
    //   this.queryParams.params = params
    // },
    getPayBankList(id) {
      this.payBankList = []
      payment.listPayBank({ companyId: id }).then((response) => {
        if (response.code === 200) {
          response.rows.forEach(item => {
            const obj = {
              incomeBankId: item.bankAccountId,
              incomeBankName: `${item.bankName}(${item.accountNum})`,
              incomeBankNo: item.accountNum
            }
            this.payBankList.push(obj)
          })
        }
      })
    },
    async showPicker(type) {
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type == 'company') {
        // 获取公司信息
        if (this.deptList.length == 0) {
          await companyList({ [this.type == 'channel' ? 'isAll' : null]: 2 }).then((response) => {
            this.deptList = response.rows
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type == 'incomeBank') {
        // await this.getPayBankList(this.queryParams.companyId)
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else if (type === 'contractStatus') {
        if (this.options.contractStatusOptions.length == 0) {
          // 合同状态
          await getDicts('contract_status').then(res => {
            this.options.contractStatusOptions = res.data
          })
        }
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      } else if (type === 'dept') {
      // 获取公司信息
        if (this.deptList.length == 0) {
          await statistics.getDeptList({ isBuss: '1' }).then((response) => {
            this.deptList = response.data
          })
        }
        this.picker.columns = this.deptList.map((ele) => ele.deptName)
      }
      this.picker.loading = false
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      if (this.picker.formKey === 'company') {
        this.queryParams.companyName = this.deptList[key].companyName
        this.queryParams.companyId = this.deptList[key].companyId
        await this.getPayBankList(this.queryParams.companyId)
        this.queryParams.incomeBankId = ''
        this.queryParams.incomeBankName = ''
      } else if (this.picker.formKey === 'incomeBank') {
        this.queryParams.incomeBankId = this.payBankList[key].incomeBankId
        this.queryParams.incomeBankName = this.payBankList[key].incomeBankName
      } else if (this.picker.formKey === 'dept') {
        this.deptName = this.deptList[key].deptName
        this.queryParams.deptId = this.deptList[key].deptId.toString()
      } else {
      // const name = this.picker.formKey+'Name'
        this.queryParams[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.contractStatusName = this.options[optionItem][key].dictLabel
      }
      this.picker.visible = false
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    async showPicker2(val) {
      if (val === 'dept') {
        // if(this.deptTreeList.length == 0){
        //   // 获取部门信息
        //   await CascaderTreeSelect().then((response) => {
        //     this.deptTreeList = response.data;
        //   })
        // }
        // this.tree = {
        //   type: val,
        //   title: '请选择所在部门',
        //   typeTree: true,
        //   treeList: this.deptTreeList,
        //   fieldNames: {}
        // }
      } else if (val === 'service') {
        if (this.serviceTypeTreeList.length == 0) {
          // 获取获取业务类型
          await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.getData(response.rows)
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.serviceTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    showCalendar(type) {
      this.datePicker.formKey = type
      if (type === 'signTime' || type === 'executionTime') {
        this.datePicker.type = 'range'
      } else {
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      // this.minDate = date
      if (this.datePicker.formKey === 'signTime') {
        const [start, end] = date
        this.queryParams.params.beginTime = this.formatDate(start)
        this.queryParams.params.endTime = this.formatDate(end)
        this.signTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      } else if (this.datePicker.formKey === 'executionTime') {
        const [start, end] = date
        this.queryParams.startTime = this.formatDate(start)
        this.queryParams.endTime = this.formatDate(end)
        this.executionTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
      } else {
        this.queryParams[this.datePicker.formKey] = this.formatDate(date)
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    treeChange(obj) {
      // if(this.tree.type === 'dept'){
      //   this.query.deptId = obj.value;
      //   this.deptName = obj.selectedOptions.map((option) => option.text).join("/")
      // }
      // console.log(this.query);
    },
    onFinishTree(obj) {
      if (this.tree.type === 'service') {
        this.queryParams.serviceTypeId = obj.value
        this.serviceTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      }
      this.tree.typeTree = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    submitForm() {
      console.log(this.queryParams)
      this.$emit('handlequery', this.queryParams)
    }
  }
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;

  .pop-title {

    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
